export class SourceAccountTagKeyValuesCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ListOperators",
            "format": ""
        },
        {
            "name": "sourceAccountTagKeyValues",
            "baseName": "sourceAccountTagKeyValues",
            "type": "Array<TagKeyValue>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceAccountTagKeyValuesCondition.attributeTypeMap;
    }
    constructor() {
    }
}
